import type { SVGProps } from 'react';
const DawnFlagAG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-AG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-AG_svg__a)">
      <path fill="#E2243B" d="M0 0h22v16H0z" />
      <path fill="#262626" fillRule="evenodd" d="M0 0h22L11 16z" clipRule="evenodd" />
      <mask
        id="dawn-flag-AG_svg__b"
        width={22}
        height={16}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" fillRule="evenodd" d="M0 0h22L11 16z" clipRule="evenodd" />
      </mask>
      <g mask="url(#dawn-flag-AG_svg__b)">
        <g filter="url(#dawn-flag-AG_svg__c)">
          <path
            fill="#FFCF3C"
            fillRule="evenodd"
            d="m11 8.8-1.804 2.035.138-2.738-2.689.14L8.643 6.4 6.286 4.267l3.048.533-.429-3.2L11 4.267 13.096 1.6l-.429 3.2 3.048-.533L13.358 6.4l1.998 1.837-2.689-.14.138 2.738z"
            clipRule="evenodd"
          />
        </g>
        <g filter="url(#dawn-flag-AG_svg__d)">
          <path
            fill="#1984D8"
            fillRule="evenodd"
            d="M0 10.667h22V6.4H0z"
            clipRule="evenodd"
          />
        </g>
        <path fill="#fff" fillRule="evenodd" d="M0 16h22v-5.333H0z" clipRule="evenodd" />
      </g>
    </g>
    <defs>
      <filter
        id="dawn-flag-AG_svg__c"
        width={9.429}
        height={9.235}
        x={6.286}
        y={1.6}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_155" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_155" result="shape" />
      </filter>
      <filter
        id="dawn-flag-AG_svg__d"
        width={22}
        height={4.267}
        x={0}
        y={6.4}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_155" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_155" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagAG;
